import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EmployeeExitClearanceDto } from 'src/app/models/EmployeeExitClearanceDto';
import { ExitClearanceApprovalDto } from 'src/app/models/ExitClearanceApprovalDto';
import { PendingExitApprovalModel } from 'src/app/models/PendingExitApprovalModel';
import { approveMovementVm } from 'src/app/models/approveMovementVm';
import { NotificationType } from 'src/app/models/notification.message';
import { ExitClearanceService } from 'src/app/services/exit-clearance.service';
import { NotificationService } from 'src/app/services/notification.service';
import { UserService } from 'src/app/services/user.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { Profile } from 'src/app/models/profile';

@Component({
  selector: 'app-exit-clearance-report',
  templateUrl: './exit-clearance-report.component.html',
  styleUrls: ['./exit-clearance-report.component.css']
})
export class ExitClearanceReportComponent implements OnInit {
  currentUser: any;
  Requests: PendingExitApprovalModel[] = [];
  filteredRequests: PendingExitApprovalModel[] = [];
  searchText: string = '';
  isPendingpprovalModalVisible = false;
  ExitRequest: EmployeeExitClearanceDto  |null =null;
  isCancelVisible:boolean=false;
  ExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  MyPendingExitRequestApprovals: ExitClearanceApprovalDto[] | undefined;
  ViewExitRequestVisible = false;
  canPrint: boolean = false;
  userList: Profile[] = [];
  selectedUser: Profile | null = null;
  selectedApproval: ExitClearanceApprovalDto | null = null;
  isChangeApproverModalVisible: boolean = false;
  selectedExitClearanceId: number | null = null;


  constructor( private notification: NotificationService,  private router: Router, public datepipe: DatePipe,private userService: UserService, private exitClearanceService:ExitClearanceService) 
  {

   


   }

  ngOnInit(): void {
      
   this. loadRecords();
  }

  filterRequests() {
    const search = this.searchText.toLowerCase();
    this.filteredRequests = this.Requests.filter(item =>
      item.exitClearance.reference?.toLowerCase().includes(search) ||
      item.exitClearance.employeeName.toLowerCase().includes(search) ||
      item.exitClearance.employeeDesignation.toLowerCase().includes(search) ||
      item.exitClearance.employeeFunctionName.toLowerCase().includes(search) ||
      item.exitClearance.employeeUnitName.toLowerCase().includes(search) ||
      item.exitClearance.status.toLowerCase().includes(search)
    );
  }

  loadUsers() {
    this.userService.getUsers().subscribe({
      next: (response) => {
        this.userList = response.responseData || [];
      },
      error: (err) => {
        console.error('Error loading users:', err);
      }
    });
  }

  openChangeApproverModal(approval: ExitClearanceApprovalDto) {
    this.loadUsers();
    this.selectedApproval = approval;
    this.isChangeApproverModalVisible = true;
  }

  closeChangeApproverModal() {
    this.isChangeApproverModalVisible = false;
    this.selectedUser = null;
    this.selectedApproval = null;
  }

  confirmApproverChange(user: Profile | null) {
    
    
    if (this.selectedApproval && user) {
      // Update approver logic here
      const requestBody = {
        exitClearanceId: this.selectedApproval.exitClearanceId,
        description:  this.selectedApproval.description, 
        userId: user.id
      }
      this.exitClearanceService.UpdateApproverByClearanceId(requestBody).subscribe(
        (response) => {
          if(response.responseData){
            if(this.selectedApproval)
            this.selectedApproval.approverEmail = user.email;
            this.closeChangeApproverModal();



          }
        }
      )
     
    }
  }

  handleCancel(): void {
    this.isPendingpprovalModalVisible = false;
    this.isCancelVisible = false;
    
  }

  setStatusColor(status?: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-success';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }}

  getStatusColor(status: string): string { 
    switch (status) {
      case "New":
        return 'badge badge-warning';
      case "Pending":
        return 'badge badge-warning';
      case "Approved":
        return 'badge badge-success';
      case "Rejected":
        return 'badge badge-danger';
        case "Closed":
          return 'badge badge-success';
          case "Cancelled":
            return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }}

    downloadExcel(): void {
      // Map your data into a format suitable for the Excel sheet
      const dataForExcel = this.Requests.map((request) => {
        const lastWorkingDate = new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        }).format(new Date(request.exitClearance.employeeLastWorkingDate));
    
        // Format Created Date to 'YYYY-MM-DD HH:mm'
        const createdDate = new Intl.DateTimeFormat('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: false, // Use 24-hour format
        }).format(new Date(request.exitClearance.createdDate));
    
        const row: any =  {
          Reference: request.exitClearance.reference,
          'SAP ID': request.exitClearance.employeeSAPId,
          'LAP Email': request.exitClearance.employeeLAPEmail,
          'Employee Name': request.exitClearance.employeeName,
          Designation: request.exitClearance.employeeDesignation,
          Function: request.exitClearance.employeeFunctionName,
          Unit: request.exitClearance.employeeUnitName,
          'Phone Number': request.exitClearance.employeePhoneNumber,
          'Personal Email': request.exitClearance.employeePersonalEmail,
          'Permanent Address': request.exitClearance.employeePermanentAddress,
          'Last Working Date': lastWorkingDate, // Piped to only date
          'Reason for Exit': request.exitClearance.reasonForExit,
          'HRBP Name': request.exitClearance.hrbpName,
          'HRBP Email': request.exitClearance.hrbpEmail,
          'Line Manager Name': request.exitClearance.lineManagerName,
          'Line Manager Email': request.exitClearance.lineManagerEmail,
          'Line Manager Authorisation': request.exitClearance.lineManagerAuthorisation,
          'Line Manager Authorisation Date': request.exitClearance.lineManagerAuthorisationDate,
          'Employee Confirmation': request.exitClearance.employeeConfirmation,
          'Employee Confirmation Date': request.exitClearance.employeeConfirmationDate,
          Status: request.exitClearance.status,
          'Created By': request.exitClearance.createdBy,
          'Created Date': createdDate, // Piped to include time
        }; 
        
        // Append approvals dynamically
        request.approvals.forEach((approver) => {
          const descKey = approver.description.replace(/\s+/g, '') + ' Approver';
          const dateKey = approver.description.replace(/\s+/g, '') + ' ApproverDate';
    
          row[descKey] = approver.approverName || '';
          row[dateKey] = approver.approvalDate 
          ? new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          }).format(new Date(approver.approvalDate))
        : '';
        });
    
        return row;
      });
      // Create a worksheet
      const worksheet = XLSX.utils.json_to_sheet(dataForExcel);
  
      // Create a workbook and append the worksheet
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'ExitClearance');
  
      // Generate an Excel file
      const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
  
      // Save the Excel file
      this.saveExcelFile(excelBuffer, 'Exit_Clearance_Forms.xlsx');
    }
  
    // Utility function to save the file
    private saveExcelFile(buffer: any, fileName: string): void {
      const data: Blob = new Blob([buffer], { type: 'application/octet-stream' });
      saveAs(data, fileName);
    }

    async open(data: PendingExitApprovalModel) 
    {
      this.MyPendingExitRequestApprovals = data.approvals;
     this.ExitRequest =data.exitClearance;
      this.ViewExitRequestVisible = true;
   
  
    }

    async openapproval(data: PendingExitApprovalModel)
    {
      this.selectedExitClearanceId = data.exitClearance.id;

      let resRequests = await this.exitClearanceService.GetExitClearanceApprovalByClearance(data.exitClearance.id).toPromise();
      this.ExitRequestApprovals = <ExitClearanceApprovalDto[]>resRequests.responseData;

      this.isPendingpprovalModalVisible = true;
    }

    async loadRecords() {
      ;
      //this.currentUser = this.tokenService.getInfo(); 
      let resRequests = await this.exitClearanceService.getAllExitClearanceForms().toPromise();
      this.Requests = <PendingExitApprovalModel[]>resRequests.responseData;
      this.filteredRequests = [...this.Requests];
    }
    async handleSubmit() {
      let id = this.selectedExitClearanceId;
      if(id)
      this.exitClearanceService.SendReminder(id).subscribe(
        (response) => {
          if (response.responseCode == "00") {
            this.notification.sendMessage({
              message: response.message,
              type: NotificationType.success
            });

        }
      })

      
    }

    close(): void {
      this.ViewExitRequestVisible = false;
      this.canPrint = false;
      
    }

    download(id: number){
      this.exitClearanceService.downloadClearance(id);
    }
    
    view(id: number){
      this.exitClearanceService.viewClearance(id);
    }



    print(requestReference:EmployeeExitClearanceDto, templateId:string) {
     // this.documentService.DownloadPDF(templateId, `Movement Request - ${requestReference}`);
    }

    async approveRequest(ExitClearanceApproval: ExitClearanceApprovalDto  ) {
      // this.isManPowerpprovalModalVisible = true;
         ; 
         const model: approveMovementVm = { id: ExitClearanceApproval.id,  message: "Approved" };
         
          this.exitClearanceService.approve(model).subscribe({
            next: (data => {
              
              if (data.responseCode == "00") {
                this.notification.sendMessage({
                  message: data.message,
                  type: NotificationType.success
                });
   
                this.loadRecords();
                this.close()
              }
              else {
   
                this.notification.sendMessage({
                message: data.message,
                  type: NotificationType.error
                });
   
              }
   
            }),
            error: ((error: any) => {
              console.log(error.error);
              ;
   
   
              this.notification.sendMessage({
                message: error.error.message,
                type: NotificationType.error
              });
            })
   
          });
   
     }

     

}
